import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS } from "../../lib/media";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0C]" data-testid="site-footer">
      <div className="container-x py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img
            src="/logo.png"
            alt="GA Signature — Painting, Electricity and Remodeling"
            className="h-24 w-auto object-contain -ml-3"
            style={{ mixBlendMode: "lighten" }}
          />
          <div className="mt-2 text-xs text-white/60 tracking-[0.2em] uppercase">{t.footer.tagline}</div>
          <p className="mt-6 text-white/65 max-w-md leading-relaxed">{t.footer.about}</p>
          <p className="mt-4 text-xs tracking-[0.2em] uppercase text-[#0055FF]">{t.common.seHablaEspanol}</p>
        </div>

        <div>
          <div className="kbd-label mb-4">{t.footer.servicesTitle}</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/services" className="hover:text-white">Kitchen Remodels</Link></li>
            <li><Link to="/services" className="hover:text-white">Bathroom Remodels</Link></li>
            <li><Link to="/services" className="hover:text-white">Interior & Exterior Painting</Link></li>
            <li><Link to="/services" className="hover:text-white">Drywall, Tile & Flooring</Link></li>
            <li><Link to="/services" className="hover:text-white">General Contracting</Link></li>
          </ul>
        </div>

        <div>
          <div className="kbd-label mb-4">{t.footer.contactTitle}</div>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-[#0055FF]" />
              <a href={`tel:${PHONE_TEL}`} className="hover:text-white" data-testid="footer-phone">
                {PHONE_DISPLAY}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-[#0055FF]" />
              <span>{ADDRESS}</span>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="w-4 h-4 mt-0.5 text-[#0055FF]" />
              <span>{t.common.openNow}</span>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-[#0055FF]" />
              <Link to="/contact" className="hover:text-white">
                {t.common.requestEstimate}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>{t.footer.copyright}</div>
          <div className="tracking-[0.2em] uppercase">Dallas, TX · 75287</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
